<span [ngSwitch]="status">
    <span *ngSwitchCase="CourseParticipationStatus.EDUCATION_MODULE_1">I</span>
    <span *ngSwitchCase="CourseParticipationStatus.EDUCATION_MODULE_2">II</span>
    <span *ngSwitchCase="CourseParticipationStatus.EDUCATION_MODULE_3"
        >III</span
    >
    <span *ngSwitchCase="CourseParticipationStatus.EDUCATION_MODULE_4">IV</span>
    <span *ngSwitchCase="CourseParticipationStatus.EDUCATION_REPETITORIUM"
        >R</span
    >
    <span *ngSwitchCase="CourseParticipationStatus.TRAINING_IN_PROGRESS"
        >FA</span
    >
    <span *ngSwitchCase="CourseParticipationStatus.TRAINING_DONE">FB</span>
    <span *ngSwitchCase="CourseParticipationStatus.EDUCATION_DONE">
        <i class="pi pi-check"></i>
    </span>
    <span *ngSwitchDefault>-</span>
</span>
